module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg3.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Have you ever been frustrated by sleeves that will not sit properly or a hemline that droops? What is the difference between a sleeve cuff and a sleeve band? Does the stitching show on your piping no matter how hard you try to avoid it? How do you trim a collar so that it has a perfectly curved edge? The answers to all of these questions, plus many more, are contained within the pages of this book, the perfect companion to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A–Z of Smocking")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("Many enthusiastic stitchers love to sit and smock but are daunted when it comes to putting a garment together. In this book we demystify the process through clear step-by-step photographs and concise instructions designed to guide you effortlessly from start to finish.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("Many of the techniques covered in this book have a long history; some are newer approaches to old problems. Scattered throughout the pages you will find helpful hints and tips to make your task even easier.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("All are tried and tested methods that will help you to produce beautifully constructed and finished garments.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("Happy stitching,")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/copy.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("Susan O’Connor, Editor")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("Country Bumpkin Publications")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("First published in Great Britain 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Search Press Limited")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Wellwood, North Farm Road,")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Tunbridge Wells, Kent TN2 3DR")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("First published in Australia by Country Bumpkin Publications")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© Country Bumpkin Publications")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Photography by Andrew Dunbar")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved. No part of this book, text, photographs or illustrations may be reproduced or transmitted in any form or by any means by print, photoprint, microfilm, microfiche, photocopier, internet or in any way known or as yet unknown, or stored in a retrieval system, without written permission obtained beforehand from Search Press.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Print ISBN: 978-1-78221-175-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eISBN: 978-1-78126-861-2")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("The Publishers and author can accept no responsibility for any consequences arising from the information, advice or instructions given in this publication.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("suppliers")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("If you have difficulty in obtaining any of the materials and equipment mentioned in this book, then please visit the Search Press website for details of suppliers:")])]), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "http://www.searchpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.searchpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright22"
  }, [_vm._v("Note")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AS&E: Australian Smocking & Embroidery magazine")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 66
// module chunks = 0